require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-code-fellows-graduate-jen.json") })
        }
      }, "path---blog-code-fellows-graduate-jen");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-code-fellows-graduate-jen!./.cache/json/blog-code-fellows-graduate-jen.json
// module id = 766
// module chunks = 231608221292675